export const JOURNEY_STATUS = {
    draft: {value: 'draft', label: 'Created'},
    generated: {value: 'generated', label:'Generated Test Cases'},
    archived: {value: 'archived', label: 'Archived'},
    failed: {value: 'failed', label: 'Failed'},
    in_progress: {value: 'in_progress', label: 'In Progress'},
}